export default {
	title: "Frases de Sabiduría",
	text: "Frase",
	author: "Autor",
	isActive: "Activo",
	create: "Nueva Frase",
	edit: "Editar Frase",
	searchPlaceholder: "Buscar frases...",
	noData: "Ninguna frase registrada",
	noDataSubtext: "Agregue frases de sabiduría personalizadas para su templo",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar esta frase? Esta acción no se puede deshacer.",
	stats: {
		total: "Total",
		active: "Activas",
	},
	form: {
		text: "Frase",
		author: "Autor",
	},
	validation: {
		textMaxLength: "La frase debe tener como máximo 500 caracteres",
		authorMaxLength: "El autor debe tener como máximo 150 caracteres",
	},
	systemQuotes: "Sistema",
	customQuotes: "Registradas",
	weightHint: "Ajuste la frecuencia con la que aparece cada tipo de frase en el panel",
	messages: {
		createSuccess: "Frase creada con éxito",
		updateSuccess: "Frase actualizada con éxito",
		deleteSuccess: "Frase eliminada con éxito",
		createError: "Error al crear la frase",
		updateError: "Error al actualizar la frase",
		deleteError: "Error al eliminar la frase",
		loadError: "Error al cargar las frases",
		weightSaved: "Proporción de frases guardada",
		weightError: "Error al guardar proporción",
	},
};
